import { createBrowserHistory } from "history";
import { useBlocker } from "react-router-dom";

export const customHistory = createBrowserHistory();

export const useDisableAllNavigation = () => {
  useBlocker(() => true);
};
